import { ContentTypeFilter } from './ContentTypeFilter';
import { CommunitiesTypeFilter } from './CommunitiesTypeFilter';
import { LocationAndZoneFilters } from './LocationAndZoneFilters';
import { FilterResultsSummary } from './FilterResultsSummary';
import { ZoneToggle } from '../ZoneToggle';

interface Community {
  id: string;
  name: string;
  members_count?: number;
}

interface FiltersBlockProps {
  open: boolean;
  postTypeFilter: string;
  onPostTypeFilterChange: (value: string) => void;
  selectedCommunity: string;
  onCommunityChange: (value: string) => void;
  locationFilter: string;
  onLocationFilterChange: (value: string) => void;
  filteredCount: number;
  totalCount: number;
  zoneFilters: {
    activeTab: 'climate' | 'hardiness';
    climateZone?: string;
    country?: string;
    hardinessZone?: string;
    showMyZoneOnly: boolean;
  };
  onZoneFiltersChange: (filters: any) => void;
}

export const FiltersBlock = ({ 
  open, 
  postTypeFilter,
  onPostTypeFilterChange,
  selectedCommunity,
  onCommunityChange,
  locationFilter,
  onLocationFilterChange,
  filteredCount,
  totalCount,
  zoneFilters,
  onZoneFiltersChange
}: FiltersBlockProps) => {
  return (
    <div
      className={`
        transition-[max-height] duration-300 ease-out
        overflow-hidden
        ${open ? 'max-h-[60vh]' : 'max-h-0'}
      `}
      aria-hidden={!open}
    >
      <div className="mx-auto max-w-2xl px-3 md:px-4">
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 md:p-4 overflow-y-auto max-h-[60vh]">
          <div className="space-y-2">
            <CommunitiesTypeFilter 
              selectedCommunity={selectedCommunity}
              onCommunityChange={onCommunityChange}
            />

            {/* Location and Climate Zone side by side */}
            <div className="grid grid-cols-3 gap-2">
              <LocationAndZoneFilters 
                className="col-span-2"
                locationFilter={locationFilter}
                onLocationFilterChange={onLocationFilterChange}
              />
              
              <ZoneToggle 
                showMyZoneOnly={zoneFilters.showMyZoneOnly}
                onToggleChange={(checked) => {
                  onZoneFiltersChange({ ...zoneFilters, showMyZoneOnly: checked });
                }}
              />
            </div>

            <div className="pt-2 border-t border-gray-200 dark:border-gray-700">
              <FilterResultsSummary 
                postTypeFilter={postTypeFilter}
                selectedCommunity={selectedCommunity}
                locationFilter={locationFilter}
                filteredCount={filteredCount}
                totalCount={totalCount}
              />
            </div>
            
            {/* Scrolling hint */}
            <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
              <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
                Close filters to resume scrolling
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
